import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TextToSpeechComponent } from './components/text-to-speech/text-to-speech.component';


@NgModule({
  declarations: [
    TextToSpeechComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    TextToSpeechComponent
  ]
})
export class TextToSpeechModule { }
